import React from 'react';

import AdminLayout from 'Pages/Admin/AdminLayout';
import {PollResultsGraph} from 'Components/MainStage';

import Base from 'Pages/MainStage/Base';
import { asset } from "Services/BaseHelpers";
import { Loading } from "Components/Partials/index";
import { translation } from "Services/TranslationHelpers";
import { Link } from "react-router-dom";

export default class LiveResults extends Base {
    /**
     * @var state
     */
    state = {
        currentSession: null,
        currentPoll: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.mountBase();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {working, currentSession, currentPoll } = this.state;

        return (
            <div className={ 'bg-questions bg-cover bg-no-repeat h-full w-full' }>
                <div className="h-48 md:h-96 w-full flex justify-center items-center pt-36 md:pt-0 pb-8">
                    <Link to={ '/admin/main-stage' }>
                        <img
                            src={ asset ( '/images/box-text.png' ) }
                            alt="logo"
                            className="p-5 mb-5 hover:cursor-pointer"
                        />
                    </Link>
                </div>

                <div className="p-4 md:px-0 pt-20 md:pt-0 lg:px-48 mx-auto pb-6 lg:pb-64 px-4 relative z-10">
                    { working && ( <Loading /> ) }

                    { !working && (
                        <React.Fragment>
                        { !currentPoll?.id &&
                            <p className="m-6 font-bold text-center">
                                No live poll running
                            </p>
                        }

                            { currentPoll?.id &&
                                <PollResultsGraph
                                    session_id={ currentSession?.id }
                                    poll_id={ currentPoll?.id }
                                />
                            }
                        </React.Fragment>
                    ) }
                </div>
            </div>
    )
        ;
    }
}
